export enum CustomValidators {
  CUSTOM_MAX_LENGTH = 'customMaxLength',
  PAYMENT_REF_MAX_LENGTH_LOCAL = 'local', // All payments (domestic and intl) are using the Local rail in Currency Cloud
  PAYMENT_REF_MAX_LENGTH_SWIFT = 'swift', // Alternative payment rail currently not in use
}
